// removed by extract-text-webpack-plugin
module.exports = {"waiting":"WaitingRoom__waiting___NSUtb"};